import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';

export interface MenuItem {
  id: string;
  label: string;
  icon?: string;
  trailingIcon?: string;
  trailingText?: string;
  disabled?: boolean;
  action?: () => void;
  submenu?: MenuItem[];
}

@Component({
  selector: 'app-m3-menu',
  standalone: true,
  imports: [CommonModule, CdkMenu, CdkMenuItem],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="m3-menu-container" cdkMenu>
      <ng-container *ngFor="let item of items(); trackBy: trackByItem">
        <div
          *ngIf="item.id === 'divider' || item.id.includes('divider')"
          class="m3-menu-divider"
          role="separator"
        ></div>

        <button
          *ngIf="
            item.id !== 'divider' &&
            !item.id.includes('divider') &&
            !item.disabled
          "
          type="button"
          class="m3-menu-item"
          cdkMenuItem
          [attr.aria-label]="item.label"
          (cdkMenuItemTriggered)="onItemClick(item)"
        >
          <div class="m3-menu-item-content">
            <div class="m3-menu-item-leading" *ngIf="item.icon">
              <span class="material-symbols-outlined m3-menu-icon">{{
                item.icon
              }}</span>
            </div>

            <span class="m3-menu-item-label">{{ item.label }}</span>

            <div
              class="m3-menu-item-trailing"
              *ngIf="item.trailingText || item.trailingIcon"
            >
              <span
                *ngIf="item.trailingText"
                class="m3-menu-item-trailing-text"
                >{{ item.trailingText }}</span
              >
              <span
                *ngIf="item.trailingIcon"
                class="material-symbols-outlined m3-menu-trailing-icon"
                >{{ item.trailingIcon }}</span
              >
            </div>
          </div>
        </button>

        <button
          *ngIf="
            item.id !== 'divider' &&
            !item.id.includes('divider') &&
            item.disabled
          "
          type="button"
          class="m3-menu-item disabled"
          [attr.aria-label]="item.label"
          [attr.aria-disabled]="true"
          [disabled]="true"
          [attr.tabindex]="-1"
        >
          <div class="m3-menu-item-content">
            <div class="m3-menu-item-leading" *ngIf="item.icon">
              <span class="material-symbols-outlined m3-menu-icon">{{
                item.icon
              }}</span>
            </div>

            <span class="m3-menu-item-label">{{ item.label }}</span>

            <div
              class="m3-menu-item-trailing"
              *ngIf="item.trailingText || item.trailingIcon"
            >
              <span
                *ngIf="item.trailingText"
                class="m3-menu-item-trailing-text"
                >{{ item.trailingText }}</span
              >
              <span
                *ngIf="item.trailingIcon"
                class="material-symbols-outlined m3-menu-trailing-icon"
                >{{ item.trailingIcon }}</span
              >
            </div>
          </div>
        </button>
      </ng-container>
    </div>
  `,
  styleUrls: ['./m3-menu.component.scss'],
})
export class M3MenuComponent {
  items = input.required<MenuItem[]>();
  isOpen = model<boolean>(false);

  itemSelected = output<MenuItem>();

  onItemClick(item: MenuItem): void {
    if (item.disabled || item.id.includes('divider')) return;

    if (item.action) {
      item.action();
    }

    this.itemSelected.emit(item);
    this.isOpen.set(false);
  }

  trackByItem(_index: number, item: MenuItem): string {
    return item.id;
  }
}

@Component({
  selector: 'app-m3-menu-trigger',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <ng-content></ng-content> `,
})
export class M3MenuTriggerComponent {}
